import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Link as RouterLink } from 'react-router';
import { hasCapability, useSession } from '../session/session';
import { sampleHref, useImporters } from './importers';

/**
 * Import beside Export on a master-data list page (CLR-59, FRD-MIG-037), with the importer's
 * sample CSV. Import opens the controlled migration flow for this record type — upload, dry run
 * reporting every rejected row, approval, apply (FRD-MIG-005, MIG-022, MIG-023) — so a page offers
 * no second way to create records. Shown only to a session that may create migration batches; the
 * API checks every step again.
 */
export function ImportButton({ recordType }: { recordType: string }) {
  const session = useSession();
  const allowed = hasCapability(session.data, 'migration.batch:create');
  const importers = useImporters(allowed);
  if (!allowed) return null;
  const importer = importers.data?.find((i) => i.recordType === recordType);
  const sample = importer === undefined ? undefined : sampleHref(importer);
  return (
    <>
      <Button
        component={RouterLink}
        to={`/migration/batches?new=${encodeURIComponent(recordType)}`}
        variant="outlined"
        startIcon={<FileUploadIcon />}
      >
        Import CSV
      </Button>
      {sample !== undefined && (
        <Button
          component="a"
          href={sample}
          download={`${recordType}-sample.csv`}
          variant="outlined"
          startIcon={<FileDownloadIcon />}
        >
          Sample CSV
        </Button>
      )}
    </>
  );
}
